"use client";

import { cloneElement, isValidElement } from "react";
import type { CaseLabelSettings } from "@/cms/case-labels";
import { announcesNews } from "@/utils/case-label";
import { caseLabelSurface, newCaseLabelStyle } from "@/utils/case-label-style";
import { useLookSystem } from "@/components/motion/LookMotion";
import { useCaseLabelSettings } from "./CaseLabelProvider";
import clsx from "clsx";

export default function PropertyLabel({
  children,
  legacy,
  settings,
  positioned = true,
  className,
  news,
}: {
  children: React.ReactNode;
  legacy?: React.ReactNode;
  settings?: CaseLabelSettings;
  positioned?: boolean;
  className?: string;
  /** Whether the label announces something new; without it, its text says. */
  news?: boolean;
}) {
  const inherited = useCaseLabelSettings();
  const lookSystem = useLookSystem();
  const selected = settings ?? inherited;
  const pulse =
    lookSystem && (news ?? announcesNews(children))
      ? { "data-re-label-pulse": "" }
      : undefined;
  if (!newCaseLabelStyle(selected))
    return (
      <>
        {pulse && isValidElement(legacy) ? cloneElement(legacy, pulse) : legacy}
      </>
    );
  return (
    <span
      data-case-label={selected.style}
      {...pulse}
      className={clsx(
        "re-case-label",
        positioned && "re-case-label-position",
        className,
      )}
      style={caseLabelSurface(selected)}
    >
      {children}
    </span>
  );
}
